console.log("buylist-search.js chargé");

document.addEventListener("DOMContentLoaded", () => {
  
  renderBuylist();
  initBuylistSearch();
});

function initBuylistSearch() {
  const input = document.getElementById("buylist-search-input");
  const resultsContainer = document.getElementById("buylist-search-results");

  if (!input) return;

  input.addEventListener("input", function () {
    const query = this.value.trim();

    if (query.length < 2) {
      resultsContainer.innerHTML = "";
      return;
    }

    fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=50`)
      .then(res => res.json())
      .then(data => {

        const products = data.resources.results.products || [];
        const buylistProducts = products.filter(
          p => p.type === "Single" && !p.tags.includes("notBuylist")
        );

        const isEnglish = (document.documentElement.lang || "")
          .toLowerCase()
          .startsWith("en");

        if (buylistProducts.length === 0) {
          resultsContainer.innerHTML = `<p>${
            isEnglish
              ? "No Buylist products found."
              : "Aucun produit Buylist trouvé."
          }</p>`;
          return;
        }

        resultsContainer.innerHTML = buylistProducts.map(p => {

          // Lire le prix Buylist à partir du tag Buylist:xxx
const buylistTag = p.tags.find(tag => tag.startsWith("Buylist:"));

if (!buylistTag) return "";

// Ex. "Buylist:1.060" -> 1.06
const buylistPrice = parseFloat(buylistTag.substring(8));

if (isNaN(buylistPrice)) return "";

const displayedPrice = getDisplayedBuylistPrice(buylistPrice);

          return `
            <div class="buylist-item" data-product-id="${p.id}">
              <a href="${p.url}">
                <img src="${p.image}" alt="${p.title}" width="60">
                <span>${p.title}</span>
                <span>${displayedPrice.toFixed(2)} $</span>
              </a>

              <button
                class="add-buylist-btn"
                data-id="${p.id}"
                data-title="${p.title}"
                data-price="${buylistPrice}"
                data-image="${p.image}">
                ${isEnglish ? "Add" : "Ajouter"}
              </button>
            </div>
          `;
        }).join("");

      });
  });
}

// BUYLISTPRICE Règles d'affaires buylist BuylistPrice BuylistPrices Rules!
function getBuylistPrice(retailPrice) {
    const price = parseFloat(retailPrice);

    if (price < 3) return null;

    if (price < 10) {
        return (price * 0.50).toFixed(2);
    }

    if (price < 20) {
        return (price * 0.60).toFixed(2);
    }

    if (price < 50) {
        return (price * 0.65).toFixed(2);
    }

    if (price < 100) {
        return (price * 0.70).toFixed(2);
    }

    return (price * 0.75).toFixed(2);
}


// document.addEventListener('click', function (event) {1
//   if (event.target.classList.contains('remove-buylist-item')) {
//     const id = event.target.dataset.id;

//     const itemElement = document.querySelector(`.buylist-item[data-id="${id}"]`);
//     if (!itemElement) return;

//     // Animation
//     itemElement.classList.add('removing');

//     setTimeout(() => {
//       let list = JSON.parse(localStorage.getItem('buylist_temp')) || [];

//       // ❗ Supprimer l’objet au complet
//       list = list.filter(item => item.id !== id);

//       localStorage.setItem('buylist_temp', JSON.stringify(list));

//       renderBuylist();
//     }, 300);
//   }
// });



// document.addEventListener('click', function (event) {
//   if (event.target.id === 'clear-buylist') {
//     localStorage.removeItem('buylist_temp');

//     // Mise à jour immédiate de l'affichage
//     renderBuylist();

//     event.target.textContent = "Liste vidée ✓";
//   }
// });



/////////////// Ouvrir le pop-up clear list
document.addEventListener('click', function (event) {
  if (event.target.id === 'clear-buylist') {
    document.getElementById('buylist-confirm-popup').style.display = 'flex';
  }
});

// Fermer (Annuler)
document.addEventListener('click', function (event) {
  if (event.target.id === 'confirm-clear-no') {
    document.getElementById('buylist-confirm-popup').style.display = 'none';
  }
});

// Confirmer (Oui)
document.addEventListener('click', function (event) {
  if (event.target.id === 'confirm-clear-yes') {
    localStorage.removeItem('buylist_temp');
    renderBuylist(); // Mise à jour en temps réel
    document.getElementById('buylist-confirm-popup').style.display = 'none';
  }
});

/////////////// Ouvrir le pop-up submit list
document.addEventListener('click', function (event) {
  if (event.target.id === 'submit-buylist') {
    document.getElementById('buylist-submit-popup').style.display = 'flex';
  }
});

// Fermer (Annuler)
document.addEventListener('click', function (event) {
  if (event.target.id === 'confirm-submit-no') {
    document.getElementById('buylist-submit-popup').style.display = 'none';
  }
});

// Confirmer (Oui)
document.addEventListener('click', function (event) {
  if (!event.target.closest('#confirm-submit-yes')) return;

  var submitPopup = document.getElementById('buylist-submit-popup');
  var searchWrapper = document.querySelector('.buylist-search-wrapper');
  var clearBuylist = document.getElementById('clear-buylist');
  var submitBuylist = document.getElementById('submit-buylist');
  var buttonContainer = document.getElementById('empty-buylist-button-container');
  var formWrapper = document.getElementById('buylist-contact-form-wrapper');

  if (submitPopup) {
    submitPopup.style.display = 'none';
  }

  if (searchWrapper) {
    searchWrapper.style.display = 'none';
  }

  if (clearBuylist) {
    clearBuylist.style.display = 'none';
  }

  if (submitBuylist) {
    submitBuylist.style.display = 'none';
  }

  if (buttonContainer) {
    buttonContainer.style.display = 'none';
  }
  if (formWrapper) {
  formWrapper.style.display = 'block';

  var backButton = document.getElementById('back-to-buylist');

if (backButton) {
    backButton.style.display = 'inline-block';
}

}
console.log(formWrapper);
console.log(getComputedStyle(formWrapper).display);

// Cache les incrémenteurs + / - et le bouton x
  document.querySelectorAll(
    '.qty-decrease, .qty-increase, .remove-buylist-item'
  ).forEach(function (button) {
    button.style.display = 'none';

})
}
);

  // document.querySelectorAll('#empty-buylist-button-container').forEach(function (container) {
  //   container.style.setProperty('display', 'none', 'important');
  // });

  // if (tempDisplay) {
  //   tempDisplay.style.display = 'none';
  // }
// document.addEventListener("DOMContentLoaded", () => {
//   renderBuylist();
// });

function getTotalCards() {
  const list = JSON.parse(localStorage.getItem('buylist_temp')) || [];
  return list.reduce((sum, item) => sum + item.qty, 0);
}

function getTotalPrice() {
  const list = JSON.parse(localStorage.getItem('buylist_temp')) || [];
  return list.reduce((sum, item) => {
    const price = getDisplayedBuylistPrice(item.price);
return sum + price * item.qty;
  }, 0);
}

function getDisplayedBuylistPrice(price) {

    const paymentType = document.getElementById("paymentType");

    const value = parseFloat(price) || 0;

    return paymentType && paymentType.checked
        ? value
        : value / 1.15;
}


function renderBuylist() {
console.trace("renderBuylist");
  const container = document.getElementById("buylist-temp-display");
  const clearBtnContainer = document.getElementById("empty-buylist-button-container");
  const list = JSON.parse(localStorage.getItem("buylist_temp")) || [];

  const siteLang = document.documentElement.lang || "";
  const isEnglish = siteLang.toLowerCase().startsWith("en");
  const quantityLabel = isEnglish ? "Quantity:" : "Quantité :";

  // --- Affichage des items ---
  if (container) {
    container.innerHTML = list.length
      ? list.map(item => `
          <div class="buylist-item" data-id="${item.id}">
            <img src="${item.image}" class="buylist-thumb">

            <div class="buylist-info">
              <span>${item.title}</span>
              <span class="buylist-price">
                ${getDisplayedBuylistPrice(item.price).toFixed(2)} $
              </span>

              <div class="buylist-qty-controls">
                <p class="buylist-qty-label">${quantityLabel}</p>
                <button class="qty-decrease" data-id="${item.id}">−</button>
                <span class="buylist-qty">${item.qty}</span>
                <button class="qty-increase" data-id="${item.id}">+</button>
              </div>
            </div>

            <button class="remove-buylist-item" data-id="${item.id}">×</button>
          </div>
        `).join("")
      : `<p>${isEnglish ? "No cards added." : "Aucune carte dans la liste."}</p>`;
  }

  // --- Bouton vider ---
  if (clearBtnContainer) {
    clearBtnContainer.style.display = list.length === 0 ? "none" : "block";
  }

  // --- Totaux ---
  const totalCards = getTotalCards();
  const totalPrice = getTotalPrice();

  const totalCardsWrapper = document.getElementById("buylist-total-wrapper");
  const totalCardsElement = document.getElementById("buylist-total-cards");

  const totalPriceWrapper = document.getElementById("buylist-total-price-wrapper");
  const totalPriceElement = document.getElementById("buylist-total-price");

  const combinedWrapper = document.getElementById("buylist-total-combined-wrapper");
  const combinedElement = document.getElementById("buylist-total-combined");

  // Total cartes
  if (totalCardsWrapper && totalCardsElement) {
    if (totalCards < 1) {
      totalCardsWrapper.style.display = "none";
    } else {
      totalCardsWrapper.style.display = "block";
      totalCardsElement.textContent = totalCards;
    }
  }

  // Total prix
  if (totalPriceWrapper && totalPriceElement) {
    if (totalPrice < 0.01) {
      totalPriceWrapper.style.display = "none";
    } else {
      totalPriceWrapper.style.display = "block";
      totalPriceElement.textContent = totalPrice.toFixed(2) + " $";
    }
  }

  const cardsLabel = isEnglish
    ? (totalCards === 1 ? "card" : "cards")
    : (totalCards === 1 ? "carte" : "cartes");

  // Total combiné
  if (combinedWrapper && combinedElement) {
    if (totalCards < 1) {
      combinedWrapper.style.display = "none";
    } else {
      combinedWrapper.style.display = "block";
      combinedElement.textContent = `${totalCards} ${cardsLabel} — ${totalPrice.toFixed(2)} $`;
    }
  }
}




document.addEventListener('click', function (event) {
  if (!event.target.classList.contains('add-buylist-btn')) return;

  const id = event.target.dataset.id;
  const title = event.target.dataset.title;
  const price = event.target.dataset.price;
  const image = event.target.dataset.image;

  let list = JSON.parse(localStorage.getItem('buylist_temp')) || [];

  // Vérifier si le produit existe déjà
  const existing = list.find(item => item.id === id);

  if (existing) {
    existing.qty += 1; // augmenter le compteur
  } else {
    list.push({
      id,
      title,
      price,
      image,
      qty: 1 // première fois → qty = 1
    });
  }

  localStorage.setItem('buylist_temp', JSON.stringify(list));

  renderBuylist();
});

document.addEventListener("click", function (event) {

    if (
        !event.target.classList.contains("qty-increase") &&
        !event.target.classList.contains("qty-decrease") &&
        !event.target.classList.contains("remove-buylist-item")
    ) {
        return;
    }

    const id = event.target.dataset.id;

  let list = JSON.parse(localStorage.getItem('buylist_temp')) || [];
  let item = list.find(p => p.id === id);

  if (!item) return;

  if (event.target.classList.contains('qty-increase')) {
    item.qty += 1;
  }

  if (event.target.classList.contains('qty-decrease')) {
    item.qty -= 1;

    if (item.qty <= 0) {
      list = list.filter(p => p.id !== id);
    }
  }

  if (event.target.classList.contains('remove-buylist-item')) {
    list = list.filter(p => p.id !== id);
  }

  localStorage.setItem('buylist_temp', JSON.stringify(list));
  renderBuylist();
});

// Formulaire buylist
function buildBuylistEmailBody() {
  const list = JSON.parse(localStorage.getItem('buylist_temp')) || [];
  const now = new Date();

  const isEnglish = (document.documentElement.lang || '').toLowerCase().startsWith('en');
  const phone = document.getElementById('buylist-customer-phone')?.value || '';

  const labels = isEnglish
    ? {
        untitledCard: 'Unnamed card',
        quantity: 'Quantity',
        price: 'Price',
        emptyList: 'No cards in the Buylist.',
        buylistNumber: 'Buylist number',
        customer: 'Customer',
        name: 'Name',
        email: 'Email',
        cardList: 'Card list',
        paymentMethod: 'Payment method',
        phone: 'Phone',
        totalCards: 'Total cards',
        totalValue: 'Total value',
      }
    : {
        untitledCard: 'Carte sans nom',
        quantity: 'Quantité',
        price: 'Prix',
        emptyList: 'Aucune carte dans la Buylist.',
        buylistNumber: 'Numéro de Buylist',
        customer: 'Client',
        name: 'Nom',
        email: 'Courriel',
        cardList: 'Liste des cartes',
        paymentMethod: 'Mode de paiement',
        phone: 'Téléphone',
        totalCards: 'Nombre total de cartes',
      totalValue: 'Montant total',
      };

  const buylistNumber = 'BL-'
    + String(now.getMonth() + 1).padStart(2, '0')
    + String(now.getDate()).padStart(2, '0')
    + String(now.getHours()).padStart(2, '0')
    + String(now.getMinutes()).padStart(2, '0')
    + String(now.getSeconds()).padStart(2, '0');

  const name = document.getElementById('buylist-customer-name')?.value || '';
  const email = document.getElementById('buylist-customer-email')?.value || '';

  const paymentType = document.getElementById("paymentType");

const paymentMethod = paymentType && paymentType.checked
    ? (isEnglish ? "Store Credit" : "Crédit boutique")
    : (isEnglish ? "Cash" : "Argent");

const totalCards = getTotalCards();
const totalPrice = getTotalPrice().toFixed(2);

  const cardsText = list.length
    ? list.map(function (item, index) {
        const title = item.title || item.name || labels.untitledCard;
        const quantity = item.quantity || item.qty || 1;
        const price = getDisplayedBuylistPrice(item.price).toFixed(2);

        return `${index + 1}. ${title} | ${labels.quantity}: ${quantity} | ${labels.price}: ${price}`;
      }).join('\n')
    : labels.emptyList;

  return {
    number: buylistNumber,
    body:
`${labels.buylistNumber}: ${buylistNumber}

${labels.customer}:
${labels.name}: ${name}
${labels.email}: ${email}
${labels.phone}: ${phone}
${labels.totalCards}: ${totalCards}
${labels.totalValue}: ${totalPrice} $
${labels.paymentMethod}: ${paymentMethod}

${labels.cardList}:
${cardsText}`
  };
}

// document.addEventListener('submit', function (event) {

//   if (event.target.id !== 'buylist-contact-form') return;

//   const buylist = buildBuylistEmailBody();

//   document.getElementById('buylist-number-field').value = buylist.number;
//   document.getElementById('buylist-body-field').value = buylist.body;

//   // Ne PAS mettre event.preventDefault()
//   // Ne PAS mettre fetch()
//   // Ne PAS mettre form.submit()

//   setTimeout(function () {

//     localStorage.removeItem('buylist_temp');
//     renderBuylist();

//     const formWrapper = document.getElementById('buylist-contact-form-wrapper');
//     if (formWrapper) {
//       formWrapper.style.display = 'none';
//     }

//     showBuylistSuccessPopup(buylist.number);

//   }, 100);

// });

// document.addEventListener('click', function (event) {

//     if (!event.target.closest('#send-buylist-form-button')) return;

//     console.count("Send Buylist");

//     const form = document.getElementById("buylist-contact-form");

//     console.log("2", form);

// const buylist = buildBuylistEmailBody();

// localStorage.setItem("buylist_last_number", buylist.number);

// const numberField = document.getElementById("buylist-number-field");
// const bodyField = document.getElementById("buylist-body-field");

// if (!numberField || !bodyField) {
//     console.error("Champs cachés Buylist introuvables.");
//     return;
// }

// numberField.value = buylist.number;
// bodyField.value = buylist.body;

// form.requestSubmit();

// });

document.addEventListener("submit", function (event) {

    if (event.target.id !== "buylist-contact-form") return;

    const buylist = buildBuylistEmailBody();

    // Sauvegarder le numéro AVANT la redirection
    localStorage.setItem("buylist_last_number", buylist.number);

    document.getElementById("buylist-number-field").value = buylist.number;
    document.getElementById("buylist-body-field").value = buylist.body;

    // IMPORTANT :
    // pas de preventDefault()
    // pas de submit()
    // pas de requestSubmit()
});


function showBuylistSuccessPopup(buylistNumber) {
  const isEnglish = (document.documentElement.lang || '').toLowerCase().startsWith('en');

  const title = isEnglish ? 'Buylist submitted' : 'Buylist soumise';

  const message = isEnglish
    ? `Your Buylist request ${buylistNumber} has been submitted successfully.<br>Within the next 24 hours, you will receive a confirmation email containing the shipping address and all the information needed to send us your cards.`
    : `Votre demande de Buylist ${buylistNumber} a été soumise avec succès.<br>Dans les 24 prochaines heures, vous recevrez un courriel de confirmation comprenant l'adresse d'expédition ainsi que toutes les informations nécessaires pour nous faire parvenir vos cartes.`;

  let popup = document.getElementById('buylist-success-popup');

  if (!popup) {
    popup = document.createElement('div');
    popup.id = 'buylist-success-popup';
    popup.className = 'buylist-modal';

    popup.innerHTML = `
      <div class="buylist-modal-content">
        <h3>${title}</h3>
        <p>${message}</p>
       <div class="buylist-modal-buttons">
   <button type="button" id="buylist-success-close" class="btn-success">
    OK
  </button>
</div>
      </div>
    `;

    document.body.appendChild(popup);
  }

  popup.style.display = 'flex';
}

document.addEventListener('click', function (event) {
  if (!event.target.closest('#buylist-success-close')) return;

  const popup = document.getElementById('buylist-success-popup');

  if (popup) {
    popup.style.display = 'none';
  }
});

document.addEventListener('click', function (event) {

    if (!event.target.closest('#buylist-back')) return;

    const popup = document.getElementById('buylist-success-popup');

    if (popup) {
        popup.style.display = 'none';
    }

    location.reload();

});





const textarea = document.getElementById("BugReportMessage");

// if (textarea && textarea.value.trim() === "") {
//     textarea.value =
// `Page: ${window.location.href}

// Browser: ${navigator.userAgent}

// Describe the problem:

// Expected behavior:

// Actual behavior:

// Steps to reproduce:
// `;
// }

document.addEventListener("DOMContentLoaded", () => {

    const button = document.getElementById("bugReportButton");
    const form = document.getElementById("bugReportForm");
    const textarea = document.getElementById("BugReportMessage");

    if (!button || !form) return;

    button.addEventListener("click", () => {

        form.classList.toggle("hidden");

        button.textContent = form.classList.contains("hidden")
            ? "⚠️ Report a Bug"
            : "✖ Close Bug Report";

        if (!form.classList.contains("hidden") && textarea && textarea.value.trim() === "") {

//             textarea.value =
// `-----------------------
// Technical information
// -----------------------

// Page:
// ${window.location.href}

// Browser:
// ${navigator.userAgent}

// -----------------------
// Describe the problem
// -----------------------


// Expected behavior:


// Actual behavior:


// Steps to reproduce:


// `;
        }

    });

});

const paymentType = document.getElementById("paymentType");

if (paymentType) {

    paymentType.addEventListener("change", () => {

        renderBuylist();

    });

}

const clearButton = document.getElementById("buylist-search-clear");
const input = document.getElementById("buylist-search-input");
const results = document.getElementById("buylist-search-results");

if (clearButton && input && results) {

    clearButton.addEventListener("click", () => {

        input.value = "";
        results.innerHTML = "";
        input.focus();

    });

}

// document.addEventListener("DOMContentLoaded", () => {

//     if (localStorage.getItem("buylist_sent") !== "1")
//         return;

//     localStorage.removeItem("buylist_sent");

//     const number = localStorage.getItem("buylist_last_number") || "";

//     localStorage.removeItem("buylist_last_number");
//     localStorage.removeItem("buylist_temp");

//     renderBuylist();

//     const wrapper = document.getElementById("buylist-contact-form-wrapper");

//     if (wrapper)
//         wrapper.style.display = "none";

//     showBuylistSuccessPopup(number);

//     history.replaceState(
//         {},
//         document.title,
//         window.location.pathname + window.location.hash
//     );

// });

document.addEventListener("DOMContentLoaded", () => {

    const params = new URLSearchParams(window.location.search);

    if (!params.has("contact_posted")) return;

    // Lire le numéro AVANT de supprimer le localStorage
    const buylistNumber = localStorage.getItem("buylist_last_number") || "";

    // Nettoyer
    localStorage.removeItem("buylist_temp");
    localStorage.removeItem("buylist_last_number");

    renderBuylist();

    const wrapper = document.getElementById("buylist-contact-form-wrapper");
    if (wrapper) {
        wrapper.style.display = "none";
    }

    showBuylistSuccessPopup(buylistNumber);

    history.replaceState(
        {},
        document.title,
        window.location.pathname + window.location.hash
    );
});